import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '../../hooks/useSiteSettings';

export const SEO = ({ 
  title, 
  description, 
  keywords,
  ogImage,
  pageName = 'home'
}) => {
  const { getSetting } = useSiteSettings();

  const siteName = getSetting('site_name', 'NaturalCare');
  const siteNameFull = getSetting('site_name_full', 'NaturalCare - Premium Natural Cosmetics');
  const faviconUrl = getSetting('favicon_url', '/favicon.ico');
  
  const seoTitle = title || getSetting(`seo_${pageName}_title`) || siteNameFull;
  const seoDescription = description || getSetting(`seo_${pageName}_description`) || getSetting('seo_home_description', 'Premium natural cosmetics and wellness products');
  const seoKeywords = keywords || getSetting(`seo_${pageName}_keywords`) || getSetting('seo_home_keywords', 'natural cosmetics, wellness');
  const seoImage = ogImage || getSetting('seo_og_image', 'https://images.unsplash.com/photo-1643379855889-850035817d24?w=1200');

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <link rel="icon" href={faviconUrl} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Helmet>
  );
};